const keys = {
  all: ['open_shifts'],
  summary: () => [...keys.all, 'summary'],
}

export default keys
